import products from "./portadas_catalogo-de-productos.jpg";
import ditributorGuide from "./portadas_guia-de-venta.jpg";

export const PdfIcons = {
    products,
    ditributorGuide,
};